export default "__VITE_ASSET__CnmGZGPq__"